export const heroIncludes = [
  'The complete 6-volume system',
  '5 exclusive bonuses included',
  '300+ pages, 100% printable',
  'Ready-to-use scripts and templates',
  'Instant access — yours forever',
]

export const volumeTitles = [
  'Volume 1 — The Intake & Flow Engine',
  'Volume 2 — The Luminary & Personal Library',
  'Volume 3 — The Social & Financial Grid',
  'Volume 4 — Transits & Timing Blueprints',
  'Volume 5 — The Relationship Synthesis',
  'Volume 6 — Career & Purpose Roadmaps',
]

export const painPoints = [
  { emoji: '⏰', text: 'You spend 3-4 hours preparing a single session. Analyzing, doubting, re-prepping.' },
  { emoji: '😰', text: 'You freeze in front of a client because you don’t know what to say in certain scenarios.' },
  { emoji: '📉', text: 'You improvise every reading. With no structure, clients don’t come back.' },
  { emoji: '💼', text: 'You want more clients, but your calendar has no room for more prep hours.' },
  { emoji: '💬', text: 'Difficult conversations make you uncomfortable, so you soften the reading.' },
  { emoji: '🗂️', text: 'Your interpretations live in ten different notebooks and you never find the right one.' },
]

export const features = [
  {
    title: 'The Intake & Flow Engine',
    pain: 'Pain: Endless preparation',
    description: 'Professional intake forms, checklists, a 15-minute workflow, and opening and closing scripts ready to use.',
  },
  {
    title: 'The Luminary & Personal Library',
    pain: 'Pain: Interpreting from scratch',
    description: 'Interpretation templates for Sun, Moon, and Rising across every sign, house, and major aspect.',
  },
  {
    title: 'The Social & Financial Grid',
    pain: 'Pain: Money and relationship questions',
    description: 'Complete interpretations of Venus, Mars, Jupiter, and Saturn with applicable financial and relational context.',
  },
  {
    title: 'Transits & Timing Blueprints',
    pain: 'Pain: Reading timing with doubt',
    description: 'Critical transits, Saturn Return, and Solar Returns with clear frameworks for reading life cycles.',
  },
  {
    title: 'The Relationship Synthesis',
    pain: 'Pain: Synastry that eats your day',
    description: 'Complete synastry, composite charts, and karmic contacts, with specific scripts for couple readings.',
  },
  {
    title: 'Career & Purpose Roadmaps',
    pain: 'Pain: Vague purpose readings',
    description: 'Midheaven, North Node, 2nd and 6th house: a complete system for vocation and purpose readings.',
  },
]

export const bonuses = [
  {
    emoji: '🎯',
    tag: 'Bonus #1',
    title: 'Emergency Reference PDF',
    description: 'Cheat sheets for signs, planets, houses, and aspects you can check in seconds mid-session, without losing the thread.',
  },
  {
    emoji: '📄',
    tag: 'Bonus #2',
    title: 'Client Deliverable Templates',
    description: 'Professional reports ready to hand your clients after every reading, in your own voice and branding.',
  },
  {
    emoji: '💬',
    tag: 'Bonus #3',
    title: 'Difficult Conversation Scripts',
    description: 'Exact wording for delivering delicate news with ethics and confidence, without leaving the client hanging.',
  },
  {
    emoji: '💼',
    tag: 'Bonus #4',
    title: 'Business of Reading Library',
    description: 'Pricing, policies, professional boundaries, and package structure so you charge what your work is truly worth.',
  },
  {
    emoji: '✨',
    tag: 'Bonus #5',
    title: 'Symbol & Glyph Master-File',
    description: 'A complete visual reference of symbols and glyphs so your materials and deliverables look flawless.',
  },
]

export const offerChecklist = [
  'Astrologer Ready — complete 6-volume system (300+ pages)',
  'Bonus #1 — Emergency Reference PDF',
  'Bonus #2 — Client Deliverable Templates',
  'Bonus #3 — Difficult Conversation Scripts',
  'Bonus #4 — Business of Reading Library',
  'Bonus #5 — Symbol & Glyph Master-File',
  'Instant digital access — yours forever',
]

export const outcomes = [
  'Prepare any session in 15 minutes instead of 4 hours.',
  'Walk into every consultation with exact answers for each scenario.',
  'Project authority with clinical, professional consultation frameworks.',
  'Deliver strategic reports that make clients come back.',
  'Charge more because your process looks and feels professional.',
  'Scale your practice without working more hours.',
]

export const faqs = [
  {
    question: 'Does this work if I am just starting out as an astrologer?',
    answer: 'Yes. Astrologer Ready gives you the structure it normally takes years to build: intake, session flow, base interpretations, and scripts. If you can already read a chart, you have everything you need to work at a professional standard from your very first consultation.',
  },
  {
    question: 'Is this an astrology course?',
    answer: 'No. It is an operating system for your practice. It does not teach astrology from zero — it hands you the infrastructure (templates, scripts, frameworks, and deliverables) so you can apply what you already know in a fraction of the time.',
  },
  {
    question: 'How do I receive the system after purchase?',
    answer: 'Immediately. Once your payment is complete you get digital access to all 6 volumes and the 5 bonuses. Use them on your phone, tablet, or computer, and print whatever you need.',
  },
  {
    question: 'How long does it take to implement?',
    answer: 'Most astrologers implement the core of the system — intake, session flow, and scripts — in a single afternoon. Everything is a fill-in-the-blank template, not theory to study.',
  },
  {
    question: 'What if it is not right for me?',
    answer: 'You are covered by a full 7-day guarantee. If you apply the system and it does not cut your prep time or improve your sessions, we refund 100% of your investment. No questions asked.',
  },
]
